module.exports = __webpack_public_path__ + "img/wecode.ddbc1738.png";